import SelectFilterModal from './SelectFilterModal'
import usePlacowkaFilterModal from '../hooks/usePlacowkaFilterModal'

export default function PlacowkaFilterModal({
	isOpen,
	onClose,
	selectedPlacowkaId,
	onApply,
	title = 'Filtruj po placowce',
	description = 'Wybierz placowke, aby zawezic liste osob.',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
}) {
	const state = usePlacowkaFilterModal(isOpen, selectedPlacowkaId)
	return (
		<SelectFilterModal
			isOpen={isOpen}
			onClose={onClose}
			onApply={onApply}
			title={title}
			description={description}
			placeholder="Szukaj placowki po nazwie..."
			emptyMessage="Nie znaleziono placowek"
			applyLabel={applyLabel}
			clearLabel={clearLabel}
			{...state}
		/>
	)
}
